import enumUtils from '@/utils/enumUtils';
import { RegimeTributarioEnumerator, ResponsavelTecnicoEnumerator, TipoGradeEixoEnumerator } from './filial';
import { EntradaSaidaEnumerator, OperacaoEntradaSaidaEnumerator, TipoOperacaoEnumeratorEntrada, TipoOperacaoEnumeratorSaida, TipoBaixaEstoque } from './operacao';

const Tela = Object.freeze({
  Filial: new enumUtils.EnumBase(2, 'Cadastro de Filiais'),
  Operacao: new enumUtils.EnumBase(3, 'Gerenciar operações'),
  ClienteFornecedor: new enumUtils.EnumBase(6, 'Cadastro de clientes ou fornecedores'),
  Classe: new enumUtils.EnumBase(7, 'Classes'),
  Subclasse: new enumUtils.EnumBase(8, 'Subclasses'),
  Grupo: new enumUtils.EnumBase(9, 'Grupos'),
  Familia: new enumUtils.EnumBase(10, 'Famílias'),
  Tamanho: new enumUtils.EnumBase(11, 'Tamanhos'),
  Cor: new enumUtils.EnumBase(12, 'Cores'),
  ClasseImposto: new enumUtils.EnumBase(13, 'Classe de imposto'),
  Cfop: new enumUtils.EnumBase(14, 'CFOP'),
  Produto: new enumUtils.EnumBase(15, 'Produtos'),
  Entrada: new enumUtils.EnumBase(16, 'Entradas'),
  NfeWebService: new enumUtils.EnumBase(17, 'NFe WebServices'),
  Saida: new enumUtils.EnumBase(18, 'Saídas'),
  Caixa: new enumUtils.EnumBase(19, 'Cadastro de caixa'),
  Banco: new enumUtils.EnumBase(20, 'Banco'),
  AdministradoraCartao: new enumUtils.EnumBase(21, 'Administradora de cartão'),
  DesefetivarSaida: new enumUtils.EnumBase(26, 'Desefetivar saída'),
  ContaPagar: new enumUtils.EnumBase(34, 'Lançar contas a Pagar'),
  ManutencaoConta: new enumUtils.EnumBase(35, 'Manutenção contas a pagar, recebíveis e carnê rápido'),
  Recebiveis: new enumUtils.EnumBase(37, 'Lançar recebíveis'),
  TabelaPreco: new enumUtils.EnumBase(41, 'Tabela de preço'),
  Cest: new enumUtils.EnumBase(57, 'CEST'),
  CarneRapido: new enumUtils.EnumBase(58, 'Manutenção Recebíveis - Carnê Rápido'),
  CarneRapidoConfig: new enumUtils.EnumBase(59, 'Configurar tela de Carnê Rápido'),
  TabelaPrecoConfigCusto: new enumUtils.EnumBase(64, 'Configuração tabela de custo padrão'),
  CreditoCliente: new enumUtils.EnumBase(65, 'Lançamento de crédito clientes ou fornecedores'),
  RelCreditoCliente: new enumUtils.EnumBase(66, 'Relatórios de crédito clientes ou fornecedores'),
  IcmsUfs: new enumUtils.EnumBase(67, 'Cadastro ICMS de UF dos destinatários'),
  IcmsUfsImport: new enumUtils.EnumBase(68, 'Importar ICMS dos destinatários'),
  Cidades: new enumUtils.EnumBase(69, 'Cadastro de cidades'),
  Composicao: new enumUtils.EnumBase(70, 'Cadastro de composição'),
  OrdemProducao: new enumUtils.EnumBase(71, 'Ordem de produção'),
  FormaPagamento: new enumUtils.EnumBase(72, 'Cadastro de forma de pagamento'),
  Setor: new enumUtils.EnumBase(74, 'Cadastro de setor'),
  TransformarOrcamentoVenda: new enumUtils.EnumBase(75, 'Permite transformar orçamento em venda'),
  Mesa: new enumUtils.EnumBase(76, 'Cadastro de mesa'),
  Marca: new enumUtils.EnumBase(11, 'Cadastro de marcas'),
  Unidade: new enumUtils.EnumBase(78, 'Cadastro de Unidade medida'),
  ClassificacaoMercadologica: new enumUtils.EnumBase(79, 'Cadastro de classificação mercadológica'),
  FechamentoCaixa: new enumUtils.EnumBase(81, 'Fechamento de caixa'),
  AdicionalProduto: new enumUtils.EnumBase(82, 'Adicional de produto'),
  AdicionalClassificacaoMercadologica: new enumUtils.EnumBase(83, 'Adicional de classificação mercadológica'),
  Favorito: new enumUtils.EnumBase(85, 'Produtos favoritos'),
  RetirarCaixa: new enumUtils.EnumBase(92, 'Permitir retirada do caixa'),
  CreditarCaixa: new enumUtils.EnumBase(93, 'Permitir creditar caixa'),
  CargaTributaria: new enumUtils.EnumBase(96, 'Cadastro de carga tributária'),
  ContaBancaria: new enumUtils.EnumBase(108, 'Conta bancária'),
  ContaBancariaMov: new enumUtils.EnumBase(112, 'Movimentação bancária'),
  AreaImpressao: new enumUtils.EnumBase(113, 'Cadastro de área de impressão'),
  BuscaVendas: new enumUtils.EnumBase(120, 'Buscar movimentos'),
  CentroCusto: new enumUtils.EnumBase(124, 'Cadastro de centro de custo'),
  Transferencia: new enumUtils.EnumBase(128, 'Cadastro de transferência de estoque'),
  TransferenciaConfig: new enumUtils.EnumBase(131, 'Tela configurar transferência de estoque'),
  ProdutoSearchConfig: new enumUtils.EnumBase(137, 'Configurar busca de produtos'),
  AreaEntrega: new enumUtils.EnumBase(141, 'Cadastro de áreas de entrega'),
  DesefetivarEntrada: new enumUtils.EnumBase(142, 'Desefetivar entrada'),
  NaoPodeAbrirCaixaPdv: new enumUtils.EnumBase(143, 'Não pode abrir o caixa do ETrade web'),
  Veiculo: new enumUtils.EnumBase(146, 'Cadastro de veículo'),
  ContagemEstoque: new enumUtils.EnumBase(153, 'Contagem de estoque'),
  EtiquetaReport: new enumUtils.EnumBase(157, 'Cadastro de etiquetas'),
  GrupoPermissoes: new enumUtils.EnumBase(158, 'Cadastro de grupos de permissões'),
  Pais: new enumUtils.EnumBase(161, 'Cadastro de países'),
  ProdutoClonar: new enumUtils.EnumBase(167, 'Produtos - Clonar um produto do cadastro'),
  TipoOs: new enumUtils.EnumBase(183, 'Cadastro de tipos de O.S.'),
  SituacaoOs: new enumUtils.EnumBase(184, 'Cadastro de situação de O.S.'),
  NaoExibirAvisoVencimento: new enumUtils.EnumBase(187, 'Não exibir tela de aviso quando o sistema está vencendo'),
  TrocarOperacao: new enumUtils.EnumBase(189, 'Permite trocar operação'),
  FecharOs: new enumUtils.EnumBase(192, 'Fechar O.S.'),
  ReabrirOs: new enumUtils.EnumBase(193, 'Reabrir O.S.'),
  ConferenciaTransfVisualizarProdutos: new enumUtils.EnumBase(194, 'Visualizar produtos durante conferência de transferência'),
  CadastrarKit: new enumUtils.EnumBase(201, 'Gourmet - Cadastro de kit'),
  Ncm: new enumUtils.EnumBase(211, 'Cadastro de NCM'),
  PermiteCadastrarSequenciaMesas: new enumUtils.EnumBase(216, 'Cadastro de mesa em sequencia'),
  NaoPermiteEfetivarFinanceiroMovimento: new enumUtils.EnumBase(228, 'Não permite efetivar financeiro do movimento'),
  NaoPermiteVerPrecoDeCustoProduto: new enumUtils.EnumBase(238, 'Não permite ver o preço de custo'),
  NaoPermiteVisualizarClassificacaoMercadologica: new enumUtils.EnumBase(278, 'Não permite visualizar classificação mercadológica'),
  PodeVerSaldoNoFechamentoCaixa: new enumUtils.EnumBase(254, 'PDV - Pode ver saldo no fechamento de caixa'),
  NaoPermiteVisualizarProdutos: new enumUtils.EnumBase(277, 'Não permite visualizar produtos'),
  NaoPermiteVisualizarUnidade: new enumUtils.EnumBase(284, 'Não permite visualizar unidade'),
  NaoPermiteVisualizarCfop: new enumUtils.EnumBase(288, 'Não permite visualizar CFOP'),
  NaoPermiteVisualizarCest: new enumUtils.EnumBase(289, 'Não permite visualizar CEST'),
  NaoPermiteVisualizarNcm: new enumUtils.EnumBase(290, 'Não permite visualizar NCM'),
  NaoPermiteVisualizarProducao: new enumUtils.EnumBase(294, 'Não permite visualizar produção'),
  NaoPermiteVisualizarVeiculo: new enumUtils.EnumBase(303, 'Não permite visualizar veículos'),
  NaoPermiteVisualizarAreaEntrega: new enumUtils.EnumBase(304, 'Não permite visualizar áreas de entrega'),
  NaoPermiteVisualizarCaixa: new enumUtils.EnumBase(306, 'Não permite visualizar caixas'),
  NaoPermiteVisualizarRecebiveis: new enumUtils.EnumBase(307, 'Não permite visualizar recebíveis'),
  NaoPermiteVisualizarContasPagar: new enumUtils.EnumBase(308, 'Não permite visualizar contas a pagar'),
  NaoPermiteVisualizarCredito: new enumUtils.EnumBase(309, 'Não permite visualizar crédito'),
  NaoPermiteVisualizarFormaPagamento: new enumUtils.EnumBase(311, 'Não permite visualizar formas de pagamento'),
  NaoPermiteVisualizarAdministradoraCartao: new enumUtils.EnumBase(312, 'Não permite visualizar administradoras de cartão'),
  NaoPermiteVisualizarContaBancaria: new enumUtils.EnumBase(317, 'Não permite visualizar contas bancárias'),
  NaoPermiteVisualizarCliente: new enumUtils.EnumBase(318, 'Não permite visualizar cliente'),
  NaoPermiteVisualizarCidade: new enumUtils.EnumBase(320, 'Não permite visualizar cidades'),
  NaoPermiteVisualizarPais: new enumUtils.EnumBase(321, 'Não permite visualizar países'),
  NaoPermiteVisualizarFiliais: new enumUtils.EnumBase(322, 'Não permite visualizar filiais'),
  NaoPermiteVisualizarGrupoPermissao: new enumUtils.EnumBase(327, 'Não permite visualizar grupos de permissão'),
  NaoPermiteVisualizarOperacoes: new enumUtils.EnumBase(332, 'Não permite visualizar operações'),
  NaoPermiteVisualizarCentroCusto: new enumUtils.EnumBase(344, 'Não permite visualizar centro de custos'),
  NaoPermiteVisualizarComposicao: new enumUtils.EnumBase(345, 'Não permite visualizar composições'),
  NaoPermiteVisualizarIcmsUfs: new enumUtils.EnumBase(347, 'Não permite visualizar ICMS dos estados'),
  PermiteBuscarMovimentoOutrosCaixasPDV: new enumUtils.EnumBase(357, 'Permite buscar movimento de outro caixa no PDV'),
  Cliente: new enumUtils.EnumBase(389, 'Cadastro de clientes'),
  BandeiraCartao: new enumUtils.EnumBase(411, 'Cadastro de bandeiras de cartão'),
  DesefetivarTransferencia: new enumUtils.EnumBase(412, 'Desefetivar Transferência'),
  EstornarFinanceiroConta: new enumUtils.EnumBase(417, 'Permite fazer o estorno do financeiro conta'),
  SalvarConfiguracaoPadraoConferenciaTransferencia: new enumUtils.EnumBase(445, 'Permite salvar configuração padrão na tela de conferência de transferência.'),
  OrdemServicoConfig: new enumUtils.EnumBase(452, 'Configurar tela de ordem serviço'),
  TelaOrdemServico: new enumUtils.EnumBase(453, 'Tela de ordem serviço'),
  BuscarOrdemServico: new enumUtils.EnumBase(455, 'Buscar ordens de serviço'),
  NaoPermiteAlterarCaixasCom: new enumUtils.EnumBase(459, 'Não permite alterar "caixas com" na entrada de produtos'),
  NaoPermiteVisualizarResumoVendas: new enumUtils.EnumBase(496, 'Não permite visualizar resumo de vendas'),
  NaoPermiteEfetivarOrdemProducaoComEstoqueZeradoNegativo: new enumUtils.EnumBase(506, 'Não permite efetivar ordem de produção com insumos com estoque zerado ou negativo'),
  ImpressaoDav: new enumUtils.EnumBase(520, 'Impressão DAV'),
  ExigirEfetivacaoImpressaoDavMovimento: new enumUtils.EnumBase(521, 'Exigir efetivação para impressão do DAV do movimento'),
  PermiteAlterarDavPadrao: new enumUtils.EnumBase(522, 'Permite alterar DAV padrão'),
  Feriado: new enumUtils.EnumBase(537, 'Feriados'),
});

const TipoEnum = Object.freeze({
  Acessar: new enumUtils.EnumBase(0, 'Acessar'),
  Gravar: new enumUtils.EnumBase(1, 'Gravar'),
  Apagar: new enumUtils.EnumBase(2, 'Apagar'),
  Permitir: new enumUtils.EnumBase(3, 'Permitir'),
  Avancado: new enumUtils.EnumBase(4, 'Avancado'),
});

const LiberacaoMessageEnumerator = Object.freeze({
  DiasVencimentoLimiteParaBloquear: new enumUtils.EnumBase(-6, '-6'),
  DiasParaFecharTelaAposSolicitarPagamento: new enumUtils.EnumBase(7, '7'),
  DiasMaiorParaComecarExibirMensagemLiberacao: new enumUtils.EnumBase(0, '0'),
  DiasVencidoParaPrimeiroVencimentoDe: new enumUtils.EnumBase(-1, '-1'),
  DiasVencidoParaPrimeiroVencimentoAte: new enumUtils.EnumBase(-5, '-5'),
});

const TipoLancaItemEnumerator = Object.freeze({
  IncluirNovo: new enumUtils.EnumBase('N', 'Inclur novo'),
  AtualizarQtde: new enumUtils.EnumBase('A', 'Atualizar qtde'),
  Incrementar: new enumUtils.EnumBase('I', 'Incrementar'),
});

const MesEnumerator = Object.freeze({
  Janeiro: new enumUtils.EnumBase(1, 'Janeiro'),
  Fevereiro: new enumUtils.EnumBase(2, 'Fevereiro'),
  Marco: new enumUtils.EnumBase(3, 'Março'),
  Abril: new enumUtils.EnumBase(4, 'Abril'),
  Maio: new enumUtils.EnumBase(5, 'Maio'),
  Junho: new enumUtils.EnumBase(6, 'Junho'),
  Julho: new enumUtils.EnumBase(7, 'Julho'),
  Agosto: new enumUtils.EnumBase(8, 'Agosto'),
  Setembro: new enumUtils.EnumBase(9, 'Setembro'),
  Outubro: new enumUtils.EnumBase(10, 'Outubro'),
  Novembro: new enumUtils.EnumBase(11, 'Novembro'),
  Dezembro: new enumUtils.EnumBase(12, 'Dezembro'),
});

export {
  Tela,
  TipoEnum,
  LiberacaoMessageEnumerator,
  RegimeTributarioEnumerator,
  EntradaSaidaEnumerator,
  TipoLancaItemEnumerator,
  OperacaoEntradaSaidaEnumerator,
  TipoOperacaoEnumeratorSaida,
  TipoOperacaoEnumeratorEntrada,
  TipoBaixaEstoque,
  ResponsavelTecnicoEnumerator,
  TipoGradeEixoEnumerator,
  MesEnumerator,
};
